import { Paragraph } from '@collab/atoms';
import { usePopup } from '@collab/features/popup';
import { useUserContext } from '@collab/features/user';
import { ModalButtons } from '@collab/organisms';

import useLogin from 'libs/users/useLogin';

export type AuthModalConfig = {
  description: string;
  redirectUrl: string;
};

const defaultAuthConfig = {
  description: 'To view this content you will have to be signed in.',
  redirectUrl: '/',
};

const useAuthProtected = (config: AuthModalConfig = defaultAuthConfig) => {
  const { isLoggedIn, isUserStatusLoading } = useUserContext();
  const login = useLogin();
  const { openPopup, closePopup } = usePopup();

  const authProtected = (protectedCallback: () => void) => {
    if (isLoggedIn) {
      protectedCallback();
    } else {
      const components = (
        <>
          <Paragraph>{config.description}</Paragraph>
          <ModalButtons
            isLoading={isUserStatusLoading}
            acceptButton={{
              text: 'Sign in / Sign up',
              onClick: () => login(config.redirectUrl),
            }}
            closeButton={{ text: 'Close', onClick: closePopup }}
          />
        </>
      );

      openPopup({
        title: 'Please sign in',
        components,
      });
    }
  };

  return authProtected;
};

export default useAuthProtected;
